import { AclosetMessageError } from '@looko-corp/acloset-react-kit';

export class AclosetCodeError extends AclosetMessageError {
  readonly code: string;

  constructor(error: any, code: string, text?: string) {
    super(error, text);
    this.code = code;
  }
}
